export const Variant = {
  PRIMARY: Symbol('primary'),
  ICON: Symbol('icon'),
};

export const Color = {
  PRIMARY: Symbol('primary'),
  LIGHT: Symbol('light'),
};
